/**---------------------------------------------
 * LoadingOn Loadingoff関数の説明
 * オーバーレイでローディングアニメーションを表示する
 * 用途：通信時
**-----------------------------------------------*/
export const LoadingOn = () =>{
  const loading = `<div id="modal-loading" class="modal modal-fx-fadeInScale is-active">
    <div class="modal-background"></div>
    <i class="ph ph-circle-notch"></i>
  </div>
  `;
  document.body.insertAdjacentHTML('beforeend',loading);

}
export const LoadingOff = () =>{
  const loading = document.getElementById(`modal-loading`);
  loading.remove();
}

/**
 * Promiseの関数を実行して、
 * 実行前にローディングを表示し、
 * 終了後にローディングを消す
 */
export const LoadingWrap = async (promiseFunc, minimumTime = 500) => {
  LoadingOn();
  const startTime = Date.now(); // 開始時間を記録

  try {
    await promiseFunc(); // 通信や処理を待つ
  } finally {
    const elapsedTime = Date.now() - startTime; // 経過時間

    if (elapsedTime < minimumTime) {
      // 足りない分だけ待つ
      await new Promise(resolve => setTimeout(resolve, minimumTime - elapsedTime));
    }

    LoadingOff();
  }
};

export const scrollToTop = (target = null) => {
  if (target) {
    target.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  } else {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }
};